module.exports = "/_next/static/images/QueryData-1-b01a64917694415f07482385208efb1c.webp";